import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { BoldBorderOutlineButton, PrimaryButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonFlateButton from "../Common/CommonFlatButton";
import { FLAT_BOLD_OUTLINE_BUTTONS, FLAT_BOLD_OUTLINE_BUTTONS_LIST } from "../../../../Data/Buttons/FlatStyle";

const FlatBoldBorderOutlineButtons = () => {
    const [buttonTooltip, setButttooltip] = useState(false);
    const buttonToggle = () => setButttooltip(!buttonTooltip);
    return (
      <Card>
        <CommonCardHeader title={BoldBorderOutlineButton} span={FLAT_BOLD_OUTLINE_BUTTONS} />
        <CardBody className="btn-showcase">
          <Btn outline color="primary-2x" id="Tooltip-47" className="btn-square">{PrimaryButton}</Btn>
          <ToolTip target="Tooltip-47" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-square btn-outline-primary-2x</ToolTip>
          {FLAT_BOLD_OUTLINE_BUTTONS_LIST.map((data, index) => (
            <CommonFlateButton key={index} item={data} outline={true}/>
          ))}
        </CardBody>
      </Card>
    );
};

export default FlatBoldBorderOutlineButtons;
